export default __webpack_public_path__ + "static/home-banner-fef56613064e259cefc6516dc1f446e4.png";